import { DefaultFetchService } from "app/services/fetchService";
import type { IWidget } from "app/components/widget/widget-types/Widget";
import type { IDataFetcherFactory } from "app/components/widget/widget-fetchers/IDataFetcher";
import {
    fetchWithFullResponseConfig,
    fetchWithFullResponseInterceptorHandlers,
} from "app/components/widget/widget-fetchers/DefaultDataFetcher";

class EndpointDataFetcherFactory<T = any> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>) {
        const fetchService = DefaultFetchService.getInstance();

        return {
            fetch: (params: any = widget.apiParams) => {
                const { endpoint, ...requestParams } = params;
                return fetchService
                    .get(endpoint, { ...requestParams, key: requestParams.keys }, fetchWithFullResponseConfig)
                    .then(...fetchWithFullResponseInterceptorHandlers);
            },

            destroy: () => undefined,
        };
    }
}

export default new EndpointDataFetcherFactory();
